import { render, staticRenderFns } from "./PMenu.vue?vue&type=template&id=8698253c"
import script from "./PMenu.vue?vue&type=script&lang=js"
export * from "./PMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports